module.exports = __webpack_public_path__ + "img/2023.52f80d42.png";